import styled from 'styled-components';

import { fromLarge } from 'styleUtils/mediaQueries';

export const PageContent = styled.div`
    ${fromLarge`
        margin-right: 80px;
    `};
`;
